import React, { useState } from "react";
import classes from "./Review.module.css";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const person = "/Assets/Icons/person2.svg";

const Review = ({ review }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className={classes.reviewContainer}>
      {/* Profile picture and review content */}
      <img
        src={review?.photoUrl || person}
        alt={review?.userName}
        className={classes.profilePicture}
      />
      <div>
        <h3>{review?.userName}</h3>
        <Stack spacing={1}>
          <Rating
            name="half-rating"
            value={review?.review?.rating}
            precision={1}
            readOnly
            sx={{
              "& .MuiRating-iconFilled": { color: "#FCC418" },
              "& .MuiRating-iconEmpty": { color: "gray" },
            }}
          />
        </Stack>
        <p className={classes.reviewText}>{review?.review?.comment}</p>
        {review?.review?.images && (
          <div className={classes.reviewImagesContainer}>
            {review?.review?.images?.map((image, index) => (
              <div key={index}>
                <img
                  src={image}
                  alt={`Review ${index + 1}`}
                  className={classes.reviewImage}
                  onClick={() => setSelectedImage(image)}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedImage && (
        <div
          className={classes.modalBackdrop}
          onClick={() => setSelectedImage(null)}
        >
          <div
            className={classes.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <FontAwesomeIcon 
              icon={faXmark}
              className={classes.closeIcon}
              onClick={() => setSelectedImage(null)}
            />
            <img
              src={selectedImage}
              alt="Enlarged review"
              className={classes.enlargedImage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Review;